<template>
  <v-container>
    <v-row>
      <v-col cols="6">
        <div class="text-subtitle-1 font-weight-bold mb-2">
          Llenar campos con información de personal
        </div>
        <div class="d-inline-flex align-center">
          <v-text-field
            v-model="search"
            label="No. personal SSC"
            rounded
            filled
            dense
            background-color="primary"
            color="secondary"
            hide-details=""
          />
          <v-btn
            color="secondary"
            rounded
            class="px-8 mx-2"
            :disabled="loading"
            :loading="loading"
            @click="triggerSearchPersonal()"
          >
            Buscar
          </v-btn>
        </div>
      </v-col>
      <v-col cols="12">
        <div class="text-subtitle-1 font-weight-bold">
          Nombre
        </div>
      </v-col>
      <v-col cols="3">
        <v-text-field
          v-model="personal.nombre"
          label="Nombre"
          rounded
          filled
          dense
          background-color="primary"
          color="secondary"
        />
      </v-col>
      <v-col cols="3">
        <v-text-field
          v-model="personal.segundoNombre"
          label="Segundo nombre"
          rounded
          filled
          dense
          background-color="primary"
          color="secondary"
        />
      </v-col>
      <v-col cols="3">
        <v-text-field
          v-model="personal.apaterno"
          label="Apellido paterno"
          rounded
          filled
          dense
          background-color="primary"
          color="secondary"
        />
      </v-col>
      <v-col cols="3">
        <v-text-field
          v-model="personal.amaterno"
          label="Apellido Materno"
          rounded
          filled
          dense
          background-color="primary"
          color="secondary"
        />
      </v-col>
      <v-col cols="12">
        <div class="text-subtitle-1 font-weight-bold">
          Datos generales
        </div>
      </v-col>
      <v-col cols="3">
        <v-text-field
          v-model="personal.fechaNacimiento"
          label="Fecha de nacimiento"
          rounded
          filled
          dense
          background-color="primary"
          color="secondary"
        />
      </v-col>
      <v-col cols="2">
        <v-text-field
          label="Edad"
          :value="getEdad(personal.fechaNacimiento)"
          rounded
          filled
          dense
          background-color="primary"
          color="secondary"
        />
      </v-col>
      <v-col cols="2">
        <v-select
          v-model="personal.fk_idSexo"
          label="Género"
          :items="sexo"
          item-color="secondary"
          item-value="id"
          item-text="title"
          rounded
          filled
          dense
          background-color="primary"
          color="secondary"
        />
      </v-col>
      <v-col cols="2">
        <v-select
          v-model="personal.fk_idEstadoCivil"
          label="Estado civíl"
          :items="estadoCivil"
          item-color="secondary"
          item-value="id"
          item-text="title"
          rounded
          filled
          dense
          background-color="primary"
          color="secondary"
        />
      </v-col>
      <v-col cols="3">
        <v-text-field
          v-model="personal.Contacto.telefonoCelular"
          label="Teléfono"
          rounded
          filled
          dense
          background-color="primary"
          color="secondary"
        />
      </v-col>
      <v-col cols="12">
        <div class="text-subtitle-1 font-weight-bold">
          Domicilio
        </div>
      </v-col>
      <v-col cols="4">
        <v-text-field
          v-model="personal.Contacto.Direccion.calle"
          label="Calle"
          rounded
          filled
          dense
          background-color="primary"
          color="secondary"
        />
      </v-col>
      <v-col cols="2">
        <v-text-field
          v-model="personal.Contacto.Direccion.ext"
          label="Número exterior"
          rounded
          filled
          dense
          background-color="primary"
          color="secondary"
        />
      </v-col>
      <v-col cols="2">
        <v-text-field
          v-model="personal.Contacto.Direccion.int"
          label="Número interior"
          rounded
          filled
          dense
          background-color="primary"
          color="secondary"
        />
      </v-col>
      <v-col cols="4">
        <v-text-field
          v-model="personal.Contacto.Direccion.entrecalles"
          label="Entre calle"
          rounded
          filled
          dense
          background-color="primary"
          color="secondary"
        />
      </v-col>
      <v-col cols="4">
        <v-text-field
          v-model="personal.Contacto.Direccion.entrecalles2"
          label="Entre calle 2"
          rounded
          filled
          dense
          background-color="primary"
          color="secondary"
        />
      </v-col>
      <v-col cols="4">
        <v-text-field
          v-model="personal.Contacto.Direccion.colonia"
          label="Colonia"
          rounded
          filled
          dense
          background-color="primary"
          color="secondary"
        />
      </v-col>
      <v-col cols="2">
        <v-text-field
          v-model="personal.Contacto.Direccion.cp"
          label="Código postal"
          rounded
          filled
          dense
          background-color="primary"
          color="secondary"
        />
      </v-col>
      <v-col cols="8">
        <v-text-field
          v-model="personal.Contacto.Direccion.referencias"
          label="Referencias"
          rounded
          filled
          dense
          background-color="primary"
          color="secondary"
        />
      </v-col>
      <v-col cols="4">
        <v-autocomplete
          v-model="personal.Contacto.Direccion.fk_idMunicipio"
          label="Municipio donde vive"
          rounded
          filled
          dense
          background-color="primary"
          color="secondary"
          :items="municipios"
          item-value="id"
          item-text="nombre"
          item-color="secondary"
        >
          <template #item="{ item, on, attrs }">
            <v-list-item
              v-bind="attrs"
              two-line
              v-on="on"
            >
              <v-list-item-content>
                <v-list-item-title>{{ item.nombre }}</v-list-item-title>
                <v-list-item-subtitle>{{ item.catEstado.title }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-autocomplete>
      </v-col>
      <v-col cols="12">
        <div class="text-subtitle-1 font-weight-bold">
          Documentación oficial
        </div>
      </v-col>
      <v-col cols="3">
        <v-text-field
          v-model="personal.curp"
          label="CURP"
          rounded
          filled
          dense
          background-color="primary"
          color="secondary"
        />
      </v-col>
      <v-col cols="3">
        <v-text-field
          v-model="personal.rfc"
          label="RFC"
          rounded
          filled
          dense
          background-color="primary"
          color="secondary"
        />
      </v-col>
      <v-col cols="3">
        <v-text-field
          v-model="personal.CUIP"
          label="No. personal SSC"
          rounded
          filled
          dense
          background-color="primary"
          color="secondary"
        />
      </v-col>
      <v-col cols="3">
        <v-btn
          rounded
          color="secondary"
          :disabled="!personalChange"
          @click="triggerUpdatePersonal()"
        >
          Guardar cambios en evaluado
        </v-btn>
      </v-col>
      <v-col cols="12">
        <v-row>
          <v-col cols="12">
            <div class="text-subtitle-1 font-weight-bold d-inline">
              Estudios
            </div>
            <agregar-estudios-dialog-component
              v-if="perfil === 'Validación'"
              :id-personal="personal.idPersonal"
            />
          </v-col>
        </v-row>
        <v-row v-if="estudios.length > 0">
          <v-col
            v-for="estudio in estudios"
            :key="estudio.id"
            cols="3"
          >
            <v-card
              tile
              color="secondary"
            >
              <v-card-title class="d-inline-block">
                <div class="text-subtitle-1 primary--text font-weight-bold">
                  {{ estudio.institucion }}
                </div>
                <div class="text-subtitle-2 primary--text">
                  {{ estudio.CatEstudios.title + ' (' + estudio.generacion + ')' }}
                </div>
              </v-card-title>
              <v-card-text>
                <div class="text-caption primary--text">
                  Observaciones
                </div>
                <div
                  v-if="estudio.observaciones !== ''"
                  class="text-body-2 primary--text font-weight-bold"
                >
                  {{ estudio.observaciones }}
                </div>
                <div
                  v-else
                  class="text-body-2 primary--text font-weight-bold"
                >
                  Sin observaciones
                </div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <v-row v-else>
          <v-col
            cols="12"
            align="center"
          >
            <div class="text-subtitle-1 font-weight-bold text--disabled">
              No hay estudios registrados.
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import moment from 'moment';
import { mapActions, mapGetters } from 'vuex';
import AgregarEstudiosDialogComponent from './AgregarEstudiosDialogComponent.vue';

export default {

  components: {
    AgregarEstudiosDialogComponent,
  },
  props: {
    personal: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      personalChange: false,
      search: '',
      loading: false,
    };
  },

  computed: {
    ...mapGetters({
      perfil: 'getPerfil',
    }),

    ...mapGetters('estudio', {
      estudios: 'getEstudios',
    }),

    ...mapGetters('sexo', {
      sexo: 'getSexo',
    }),

    ...mapGetters('estadoCivil', {
      estadoCivil: 'getEstadoCivil',
    }),

    ...mapGetters('municipio', {
      municipios: 'getMunicipios',
    }),
  },

  watch: {
    personal: {
      handler() {
        this.personalChange = true;
      },
      deep: true,
    },
  },

  methods: {
    ...mapActions('personal', ['updatePersonal', 'saveCuip', 'searchPersonal']),

    getEdad(fechaNacimiento) {
      return `${moment().diff(fechaNacimiento, 'years')} años`;
    },

    async triggerUpdatePersonal() {
      await this.updatePersonal(this.personal);
      await this.saveCuip(this.personal);
    },

    async triggerSearchPersonal() {
      this.loading = true;
      const resultPersonalSearched = await this.searchPersonal(this.search);
      if (resultPersonalSearched) {
        this.$emit('update-personal', resultPersonalSearched);
      }
      this.search = '';
      this.loading = false;
    },
  },
};
</script>
